<template>
  <div
    v-lazyload-script="{
      url: 'https://www.youtube.com/player_api',
      name: 'youtube',
    }"
    class="video-component"
  >
    <div v-if="displayImage">
      <youtube ref="youtube" :video-id="videoid" @playing="playing"></youtube>
    </div>
    <div v-if="!displayImage">
      <div :class="'embed-responsive embed-responsive-' + aspectratio">
        <div v-if="videoid !== ''" :id="playerId" class="embed-responsive-item"></div>
        <youtube ref="youtube" :video-id="videoid" @playing="playing"></youtube>
      </div>
      <slot></slot>
      <img
        v-if="!!$slots.default ? false : true"
        alt="yout tube preload image"
        :data-srcset="transparentPixel"
        :src="transparentPixel"
        class="img-responsive placeholder lazyload"
      />
      <button
        v-if="videoid != ''"
        ref="playbtn"
        class="play-btn"
        title="play or pause video"
        :aria-label="ariaLabel"
        @click.once="togglePlaceholder()"
      >
        <span></span>
      </button>
    </div>
  </div>
</template>

<script>
import { animate } from 'animejs';

export default {
  name: 'videoplaceholder',
  props: {
    videoid: { required: false, type: String, default: '' },
    aspectratio: { required: false, type: String, default: '16by9' }, // aspect ratio can be 16by9 and 4by3
    lazyPoster: { required: false, type: Boolean, default: false },
    displayImage: { required: false, type: Boolean, default: false },
  },
  data() {
    return {
      playerId: `player-${this.videoid}-${Date.now()}`,
      placeholder: null,
      ytPlayer: null,
      playbackListener: false,
      duration: 0,
      playerRendered: false,
      videoPlaceholderImg: false,
      transparentPixel:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM88x8AAp0BzdNtlUkAAAAASUVORK5CYII=',
    };
  },

  computed: {
    player() {
      return this.$refs.youtube.player;
    },
    hasPoster() {
      return !!this.$slots.default;
    },
  },
  mounted() {
    /* istanbul ignore if */
    if (this.videoid === '') {
      return;
    }

    this.placeholder = this.$el.querySelector('.img-responsive');
  },

  methods: {
    togglePlaceholder() {
      this.$refs.youtube.player.playVideo();
      this.animatePoster().then(() => {
        this.placeholder.style.display = 'none';
        this.$refs.playbtn.style.display = 'none';
      });
    },

    animatePoster() {
      return new Promise((resolve) => {
        animate([this.placeholder, this.$refs.playbtn], {
          opacity: 0,
          duration: 500,
          onComplete: resolve,
        });
      });
    },

    setupPlayerAndBindToEvents() {
      /* istanbul ignore next */
      this.setupYT().then(() => {
        this.ytPlayer = new YT.Player(this.playerId, {
          playerVars: {
            showinfo: 0,
            rel: 0,
            modestbranding: 1,
          },
          videoId: this.videoid,
          events: {
            onReady: () => {
              this.playerRendered = true;
              this.ytPlayer.playVideo();
            },
          },
        });
      });
    },

    playVideo() {
      this.player.playVideo();
    },
    playing() {},

    setupYT() {
      return Promise.resolve().then(() => this.player.playVideo());
    },
  },
};
</script>
